export const iconFontAwesomeAutomotiveCarBattery = (
	<i className="fa-solid fa-car-battery"></i>
);
